'use strict';
import Users from '../controllers/user.controller';
import isSuperAdmin from '../services/jwt/isSuperAdmin';

export default async function paid({ next, router }) {

    // Check if the user is a super-admin
    if (isSuperAdmin(localStorage.getItem('superAdmin')) !== true) {
        let active = await Users.isActive();

        if (active != true) {
            let info = await Users.getInfo();

            // If the user is not active, check if they are a platinum curator
            if (info.subscription.planDetails.plan_type != null) {
                return next('/edit-user/notPaid')
            }
        }
    }

    return next();
}